import { createApp } from "@shopify/app-bridge";
import { VITE_SHOPIFY_APP_KEY } from "../utils/constants";
import {
  AppLink,
  NavigationMenu,
  TitleBar,
  Button,
  Redirect
} from "@shopify/app-bridge/actions";
import intl from "../i18n/intl";
export default class AppBridge {
  /**
   * 检测实例
   * @returns
   */
  static exist() {
    return this.app !== undefined;
  }

  /**
   * 创建实例
   * @param {*} shop
   * @param {*} host
   */
  static set(shop, host) {
    const apiKey = VITE_SHOPIFY_APP_KEY;
    this.app = createApp({
      apiKey: apiKey,
      host: host,
      shop:shop
    });
    //保存数据
    window.DSMAppAuth = this.app;
    // 注册路由
    //保存数据
    this.routeSet();
    return this.app;
  }

  // 创建顶部标题/按钮/面包屑
  static setTitleBar(titleObj, url, func, btnState, secondTitle) {
    // console.log(titleObj, url, func, btnState);
    const app = this.app;
      let titleBlock = {
        title: titleObj,
      };
    
      if (titleObj === "Branding" && Boolean(func)) {
        const saveButton = Button.create(app, {
          label: intl.get('Upload logo'),
          // loading: !Boolean(func) || btnState,
        });
        saveButton.subscribe(Button.Action.CLICK, () => {
          // Do something with the click event
          func();
        });
        titleBlock = {
          title: titleObj,
          buttons: {
            primary: saveButton,
          },
        };
      }


        // 一级页面
        const firstUrl = {
          "/admin/dashboard": "Dashboard",
          "/admin/find_products": "Find Products",
          "/admin/customService": "Custom Service",
          "/admin/partnerShip": "Partnership",
          // "/admin/websiteOptimization": "Site Optimization",
      }
      // 二级页面
      const secUrl = [
          'Branding',
          'Private storage',
          'Print On Demand',
          'Landing Page Builder',
          'Freight calculation',
          'Affiliate Program',
          'Feature Requests',
          'Partners',
          // 'Website Pagespeed',
          // 'Website Build',
          'Trending Products',
          'Winning Products',
          'New Products',
      ]
      // 注册面包屑页面
      if(secUrl.includes(titleObj)) {
        const backUrl = url.indexOf("/admin/dashboard") > -1 ? "/admin/dashboard" : 
            ['/admin/find_products'].includes(url) ? "/admin/find_products" : 
            url.indexOf("/admin/find_products/trendy-products/trendy") > -1 ? "/admin/find_products/trendy-products/trendy" : 
            url.indexOf("/admin/find_products/recommended-category/winning") > -1 ? "/admin/find_products/recommended-category/winning" :
            url.indexOf("/admin/find_products/new-products") > -1 ? "/admin/find_products/new-products" :
            url.indexOf("/admin/customService") > -1 ? "/admin/customService" :
            // url.indexOf("/admin/websiteOptimization") > -1 ? "/admin/websiteOptimization" : 
            url.indexOf("/admin/partnerShip") > -1 ? "/admin/partnerShip" : "/admin/dashboard";
        const breadcrumb = Button.create(app, { label: firstUrl[backUrl] });
        breadcrumb.subscribe(Button.Action.CLICK, () => {
            app.dispatch(Redirect.toApp({ path: backUrl }));
        });
        titleBlock['breadcrumbs'] = breadcrumb;
    }
      const PageTitle = TitleBar.create(app, {title: 'Dashboard'});
      PageTitle.set(titleBlock);
      return app;
  }
  //需要注册的页面调这个方法，然后传标题名称进来就行
  // 创建shopify侧边导航栏
  static routeSet() {
    let app = this.app;
    
    // 增加自定义shopify左侧导航栏
    const Subcription = AppLink.create(app, {
      label: "Plan",
      destination: "/admin/subscribe",
    });
    const FindProducts = AppLink.create(app, {
      label: "Find Products",
      destination: "/admin/find_products",
    });
    const Sourcing = AppLink.create(app, {
      label: "Sourcing",
      destination: "/admin/sourcing",
    });
    const ListProducts = AppLink.create(app, {
      label: "List Products",
      destination: "/admin/import-list",
    });
    const OrderList = AppLink.create(app, {
      label: "Orders",
      destination: "/admin/order_list",
    });
    const CustomService = AppLink.create(app, {
      label: "Custom Service",
      destination: "/admin/customService",
    });
    const PartnerShip = AppLink.create(app, {
      label: "Partnership",
      destination: "/admin/partnerShip",
    });
    // const websiteOptimization = AppLink.create(app, {
    //   label: "Site Optimization",
    //   destination: "/admin/websiteOptimization",
    // });
    const Settings = AppLink.create(app, {
      label: "Settings",
      destination: "/admin/settings",
    });
    NavigationMenu.create(app, {
      items: [
        Subcription,
        FindProducts,
        Sourcing,
        ListProducts,
        OrderList,
        CustomService,
        PartnerShip,
        // websiteOptimization,
        Settings,
      ],
      // active: FindProducts,
    });
  }
}
